import * as React from "react";
import Recipe from "../components/Recipe/Recipe";

const RecipePage = () => {
  return (
    <div className="container">
      <Recipe />
    </div>
  );
};

export default RecipePage;
